var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNounReport7463198 = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 28,
  height: 28,
  viewBox: "-5 -10 110 135",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M87.5 91.668v-75a2.088 2.088 0 0 0-2.082-2.086h-6.25v-6.25a2.09 2.09 0 0 0-2.086-2.082h-62.5A2.084 2.084 0 0 0 12.5 8.332v75a2.088 2.088 0 0 0 2.082 2.086h6.25v6.25a2.09 2.09 0 0 0 2.086 2.082h62.5a2.084 2.084 0 0 0 2.082-2.082M16.668 81.25V10.418H75v4.164H22.918a2.086 2.086 0 0 0-2.086 2.086V81.25zm66.668 8.332H25V18.75h58.332z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M51.043 62.5a15.64 15.64 0 0 0 15.625-15.625 2.09 2.09 0 0 0-2.086-2.082H53.125V33.332a2.084 2.084 0 0 0-2.082-2.082 15.62 15.62 0 0 0-13.531 7.812 15.62 15.62 0 0 0 0 15.625 15.62 15.62 0 0 0 13.53 7.813zm11.27-13.543h-.004a11.45 11.45 0 0 1-7.941 8.887 11.45 11.45 0 0 1-11.535-2.993l8.84-5.894zM48.958 35.605v10.152l-8.445 5.629v.004a11.453 11.453 0 0 1 8.445-15.785z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M57.293 42.707H68.75a2.084 2.084 0 0 0 2.082-2.082c-.008-7.477-6.066-13.531-13.539-13.543a2.086 2.086 0 0 0-2.086 2.086v11.457a2.09 2.09 0 0 0 2.086 2.082zm2.082-11.227v.004a9.41 9.41 0 0 1 7.059 7.059h-7.059zM72.918 69.793h-37.5a2.082 2.082 0 1 0 0 4.164h37.5a2.081 2.081 0 1 0 0-4.164M72.918 78.125h-37.5a2.085 2.085 0 1 0 0 4.168h37.5a2.085 2.085 0 0 0 0-4.168"
})));
export { SvgNounReport7463198 as ReactComponent };
export default __webpack_public_path__ + "assets/images/noun-report-7463198.svg";